import usePostTrackInteraction, {
    InteractionType
} from '../api/usePostTrackInteraction';
import { useMutation } from 'react-query';

export const useTrackArticleView = (slug: string, from: string) => {
    const sessionKey = 'track_article_view';

    const postTrackInteraction = usePostTrackInteraction();
    const postTrackInteractionMutation = useMutation(postTrackInteraction);

    if (sessionStorage.getItem(sessionKey) !== window.location.href) {
        sessionStorage.setItem(sessionKey, window.location.href);

        postTrackInteractionMutation.mutate({
            interactionType: InteractionType.ArticlePageView,
            questionId: null,
            metadata: {
                slug,
                from
            },
            interactionId: null,
            url: window.location.href
        });
    }
};

const useTrackPageView = (questionId: number | null = null) => {
    const sessionKey = 'track_page_view';

    const postTrackInteraction = usePostTrackInteraction();
    const postTrackInteractionMutation = useMutation(postTrackInteraction);

    if (sessionStorage.getItem(sessionKey) !== window.location.href) {
        sessionStorage.setItem(sessionKey, window.location.href);

        postTrackInteractionMutation.mutate({
            interactionType: InteractionType.PageView,
            questionId,
            metadata: null,
            interactionId: null,
            url: window.location.href
        });
    }
};

export default useTrackPageView;
